export default "__VITE_ASSET__abe01afe__"